import { ShieldAlert, X } from "lucide-react";

export default function SafetyBanner({ onDismiss }) {
  return (
    <div
      role="region"
      aria-label="Safety information"
      data-testid="safety-banner"
      className="flex items-center gap-3 rounded-2xl px-4 py-3 text-sm"
      style={{
        background:
          "linear-gradient(180deg, hsla(214,55%,95%,0.85), hsla(230,55%,94%,0.75))",
        border: "1px solid hsla(214,40%,82%,0.7)",
        color: "hsl(36 10% 18%)",
      }}
    >
      <ShieldAlert
        className="h-4 w-4 shrink-0"
        style={{ color: "hsl(var(--cg-cosmic))" }}
        strokeWidth={1.7}
      />
      <p className="flex-1 text-[13px] leading-5">
        If you are in immediate danger, call emergency services. US: call or
        text <strong>988</strong> for crisis support.
      </p>
      <button
        type="button"
        onClick={onDismiss}
        aria-label="Dismiss safety banner"
        data-testid="safety-banner-dismiss"
        className="inline-flex h-7 w-7 items-center justify-center rounded-full text-muted-foreground transition-colors hover:bg-white/70 hover:text-foreground"
      >
        <X className="h-3.5 w-3.5" />
      </button>
    </div>
  );
}
